

export const goaPayoutLevelsSelectList = [
    { label: "Low", value: "low" },
    { label: "Medium", value: "medium" },
    { label: "High", value: "high" },
]

export const goaGameSelectList = [
    { label: "Northern 6", value: "northern6" },
    { label: "Northern 7", value: "northern7" },
    { label: "Northern Classic", value: "northernClassic" },
    { label: "Northern Plus 1", value: "northernPlus1" },
    { label: "Northern Plus 2", value: "northernPlus2" },
    { label: "Northern Plus 3", value: "northernPlus3" },
    { label: "Northern Plus 5", value: "northernPlus5" },
    { label: "Northern Super Link", value: "northernSuperLink" },
];